const facts = [
  { value: '18+', label: 'лет практики' },
  { value: '100+', label: 'корпоративных проектов' },
  { value: '450+', label: 'тренингов и сессий' },
  { value: '4500+', label: 'участников' },
];

const features = [
  'Компании Беларуси, России, Казахстана и Израиля',
  'Практикующий бизнес-тренер, не «теоретик с кафедры»',
  'Работаю с компаниями от 20 до 1000+ сотрудников',
];

export default function WhyWorkWithMe() {
  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Почему компании выбирают Алексея Сивко
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          18+ лет в корпоративном обучении. Помогаю компаниям не просто проводить тренинги, а выстраивать систему обучения с измеримым бизнес-результатом.
        </p>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="grid grid-cols-2 gap-4 mb-8">
              {facts.map((f, i) => (
                <div key={i} className="bg-white rounded-xl p-5 text-center border border-gray-100">
                  <div className="text-3xl md:text-4xl font-extrabold text-teal-600">{f.value}</div>
                  <div className="text-sm text-gray-600 mt-1">{f.label}</div>
                </div>
              ))}
            </div>
            <div className="space-y-3">
              {features.map((f, i) => (
                <div key={i} className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-sm text-white"></i>
                  </div>
                  <span className="text-gray-700">{f}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="flex justify-center">
            <div className="w-64 h-64 md:w-72 md:h-72 rounded-2xl overflow-hidden">
              <img
                src="https://static.readdy.ai/image/045fa1b133efd9567759baab28602a6d/d5f5f47c7d94e3dc67c5ef073553230f.jpeg"
                alt="Алексей Сивко — бизнес-тренер и коуч"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}